<template>
      <div class="mx-auto w-50 rounded my-5" style="height:800px" id="simcardCharge">
          <div class="d-flex justify-content-around ">
              <div class="shadow w-25 mt-3 d-flex align-items-center justify-content-center border-raduis font-charge " :class="{'on' : route.query.mode == 'charge'}" role="button"  style="height:3em" @click="setMode($event,'charge')">
                  شارژ
              </div>
              <div class="shadow w-25 mt-3 d-flex align-items-center justify-content-center border-raduis font-charge" :class="{'on' : route.query.mode == 'internet'}"  role="button"  style="height:3em" @click="setMode($event,'internet')">
                  اینترنت
              </div>
          </div>
          <div class="mt-3">
              <div class="position-relative input-phone-box hasType">
                  <label class="px-3 mt-2 text-muted">لطفا شماره همراه خودتان را وارد نمایید</label>
                    <div class="form-group form-group-lg search-input" style="margin-bottom: 0;width: 100%;"> 	
                        <label v-if="card.mobile && card.mobile.length >= 11" @click="card.mobile = '' ">تغییر شماره</label>
                        <label v-else @click="card.getMobileList" style="top: 13px"><img src="https://radap.ir/imagesUploaded/other/contact.png" width="25" /></label>
                        <form autocomplete="off">
                            <input class="form-control default-input undefined w-100 text-start pr-3" name="myChargeMobile"  maxlength="11" minlength="11" type="tel" dir="ltr" v-model="card.mobile" >
                        </form>
                        <ul class=" list-group search-suggestion" id="searchResultUl" v-if="card.mobileList">
                            <li class="list-group-item py-2 d-flex justify-content-between" v-for="item in card.mobileList" :key="item.id" >
                                <span @click="card.mobile = item.mobile,card.mobileList = ''">{{convertToPersian(String(item.mobile))}}</span>
                                <span @click="card.mobile = item.mobile,card.mobileList = ''">{{item.name}}</span>
                                <span @click="card.getPopupCardName(item.mobile,item.name)"><i class="bi bi-edit"></i></span>
                            </li>
                        </ul>
                        
                    </div>
              </div>
          </div>
          <label class="px-3 mt-2 text-muted ">لطفا اپراتور خود را انتخاب نمایید</label>
          <div class="my-3 d-flex justify-content-center">
              <div class="type-item irancell irancell-operator " role="button" data-operator="MTN" data-operator-fa="ایرانسل"><img  @click="card.setOperator($event)" src="https://radap.ir/imagesUploaded/card/irancell.png"></div>
              <div class="type-item hamrahaval hamrahaval-operator " role="button" data-operator="MCI" data-operator-fa="همراه اول"><img  @click="card.setOperator($event)" src="https://radap.ir/imagesUploaded/card/hamrahaval.png"></div>
              <div class="type-item rightel rightel-operator " role="button" data-operator="RTL" data-operator-fa="رایتل"><img  @click="card.setOperator($event)" src="https://radap.ir/imagesUploaded/card/rightel.png"></div>
          </div>
          <label class="px-3 mt-2 text-muted">ایا سیم کارتتان را ترابرد کرده اید؟</label>
          <input type="radio" name="mnp" value="1"> <label class="pl-3 text-muted">بله</label>
          <input type="radio" name="mnp" checked value="2"> <label class="pl-3 text-muted">خیر</label>
          <div class="mt-3" v-if="card.shegefangiz">
            <div class="switchToggle ">
                <span class="irancell checked " @click="card.setTypeIrancell($event)" data-number="normal">عادی</span>
                <span class="irancell" @click="card.setTypeIrancell($event)" data-number="amazing">شگفت انگیز</span>
            </div>
          </div>
          <div class="mt-3">
                  <div class="currency-Input">
                    <form autocomplete="off" >
                        <input class="form-control default-input text-start pr-3" type='tel' placeholder="مبلغ دلخواه خود را به تومان وارد کنید" v-model="card.amount" >
                    </form>
                  </div>
          </div>
          <div class="d-flex mt-3 justify-content-center flex-wrap">
              <div class="buttons-template">
                  <button class="btn btn-outline-secondary ml-1 border-raduis btn-price" @click="card.amount = 2000">
                      <span class="">۲,۰۰۰</span>
                      <small class="mr-1">تومان</small>
                  </button>
              </div>
              <div class="buttons-template">
                  <button class="btn btn-outline-secondary ml-1 border-raduis btn-price" @click="card.amount = 5000">
                      <span class="">۵,۰۰۰</span>
                      <small class="mr-1">تومان</small>
                  </button>
              </div>
              <div class="buttons-template">
                  <button class="btn btn-outline-secondary ml-1 border-raduis btn-price" @click="card.amount = 10000">
                      <span class="">۱۰,۰۰۰</span>
                      <small class="mr-1">تومان</small>
                  </button>
              </div>
              <div class="buttons-template">
                  <button class="btn btn-outline-secondary ml-1 border-raduis btn-price" @click="card.amount = 20000">
                      <span class="">۲۰,۰۰۰</span>
                      <small class="mr-1">تومان</small>
                  </button>
              </div>
          </div>
          <button class="btn btn-success w-100 mt-3 border-raduis h-5" style="border-radius: 21px;height: 50px;font-weight: 700;font-size: 20px;" @click="card.goFactor">ادامه</button>
          <card-benefit />
      </div>
    <card-modal />
    <card-name />
</template>
  
<script setup>
import cardModal from '../../popup/CardTemp.vue'
import CardName from '../../popup/CardName.vue'
import CardBenefit from '../../popup/CardBenefit.vue'
import { reactive, ref,watch,computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { convertToPersian } from '@/composables/digits';
import { useCard } from '@/store/card'
let card = useCard()

card.reset()
let router = useRouter()
let route = useRoute()

watch(card, () => {
    if(card.mobile){
        card.mobile = convertToPersian(String(card.mobile))
    }
    card.amount = convertToPersian(String(card.amount))
});
card.type = 'normal'
card.mode = 'charge'
card.modeFa = 'شارژ مستقیم'
function setMode(e,mode){
document.querySelector('.on').classList.remove('on')
e.target.classList.add('on')
router.push({name:"Simcard",query:{mode:mode}})
}
</script>
<style scoped>
  .font-charge{
      font-weight: 900;
      font-size: 18px;
      line-height: 28px;
      font-style: normal;
      font-weight: 900;
      line-height: 40px;
      color: #2b3674;
  }
  .border-raduis{
      border-radius: 30px;
  }
  label {
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 22px;
      text-align: right;
      margin-bottom: 10px;
  }
  .default-input {
      background: #fff;
      border: 1px solid #bebebe;
      box-sizing: border-box;
      border-radius: 21px !important;
      height: 50px;
      font-weight: 700;
      font-size: 20px;
  }
  .type-item img {
      width: 64px;
      height: 64px;
      mix-blend-mode: luminosity;
      opacity: .4;
  }
  .type-item{
      width: 30%;
      text-align: center;
  }
  .active img{
      mix-blend-mode: normal;
      opacity: 1;
  }
  .switchToggle {
      height: 50px;
      background: #fff;
      border: 1px solid #bebebe;
      border-radius: 21px;
      display: flex;
      font-style: normal;
      font-weight: 900;
      font-size: 18px;
      line-height: 28px;
      text-align: center;
  }
  .switchToggle span.irancell.checked {
      background-color: #fff2c2;
      /* border: 1px solid #ffcb08; */
  }
  .switchToggle span {
      width: 50%;
      border-radius: 21px;
      padding-top: 10px;
      cursor: pointer!important;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  }
  .w-18{
  width: 18%;
  }
  .btn-price span,.btn-price small{
      font-weight: 700;
      font-size: 15px;
      color: black;
  }
  .h-5{
      height: 5em;
  }
  .buttons-template{
      margin-bottom: 5px;
  }
  .on{
      background-color: #cfc9c9;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
  @media (max-width: 772px) {
    #simcardCharge {
      width: 100% !important;
      padding: 1em !important;
    }
  }
  .search-suggestion{
    max-height: 179px;
    overflow: auto;
    position: absolute;
    width: 90%;
    z-index: 2;
    top: 54px;
  }
</style>